import React from 'react'
import Client from './containers/client'
import Search from './containers/search'
import Welcome from './containers/welcome'
import Diamond from './containers/diamond'
import Jewelry from './containers/jewelry'
import Summary from './containers/summary'
import Login from './containers/login'
import MainLayout from './components/layout-main'
import RequiresAuth from './containers/requires-auth'
import NotFound from './components/404'
import { Router, Route, Redirect, browserHistory, applyRouterMiddleware } from 'react-router'
import { useScroll } from 'react-router-scroll'

const Routes = props => (
  <Router history={browserHistory} render={applyRouterMiddleware(useScroll())}>
    <Redirect from='/' to='/welcome' />
    <Route path='/login' component={Login} />
    <Route component={RequiresAuth}>
      <Route component={MainLayout}>
        <Route path='/welcome' component={Welcome} />
        <Route path='/client' component={Client} />
        <Route path='/diamond' component={Diamond} />
        <Route path='/jewellery' component={Jewelry} />
        <Route path='/search' component={Search} />
        <Route path='/summary' component={Summary} />
        <Redirect from='/jewelry' to='/jewellery' />
        <Route path='*' component={NotFound} />
      </Route>
    </Route>
    <Route path='*' component={Login} />
  </Router>
)

export default Routes



// WEBPACK FOOTER //
// ./src/routes.js